import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { composeUrl } from 'app/core/shared/helper/url.helper';
import { OptionTypeService } from 'app/modules/option-type/services/option-type.service';
import { BehaviorSubject, Observable, take } from 'rxjs';
import { Response } from 'app/modules/corrective-maintenance/model';

@Injectable({ providedIn: 'root' })
export class CmDashboardService {
    private _FieldSummary: BehaviorSubject<any> = new BehaviorSubject(null);

    constructor(
        private _httpClient: HttpClient,
        private metadataServices: OptionTypeService
    ) {}

    get fieldSummary$(): Observable<any> {
        return this._FieldSummary.asObservable();
    }

    getCmFieldSummary(params: any): Observable<Response<any>> {
        const url = composeUrl(`v1/WIM/DashboardWIM/cm/fields/summary`, params);

        let response = this._httpClient.get<Response<any>>(url).pipe(take(1));

        response.subscribe((res) => {
            this._FieldSummary.next(res);
        });

        return response;
    }

    getCmStringSummary(params: any): Observable<Response<any>> {
        const url = composeUrl(
            `v1/WIM/DashboardWIM/cm/strings/summary`,
            params
        );

        let response = this._httpClient.get<Response<any>>(url).pipe(take(1));

        return response;
    }

    getCmFieldSummaryExport(): Observable<Blob> {
        const url = composeUrl(`v1/WIM/DashboardWIM/cm/fields/summary/export`);
        return this._httpClient
            .get<Blob>(url, { responseType: 'blob' as 'json', params: { PageSize: 9999 } })
            .pipe(take(1));
    }

    getCmStringSummaryExport(): Observable<Blob> {
        const url = composeUrl(`v1/WIM/DashboardWIM/cm/strings/summary/export`);
        return this._httpClient
            .get<Blob>(url, { responseType: 'blob' as 'json', params: { PageSize: 9999 } })
            .pipe(take(1));
    }
}
